import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManager, User } from 'oidc-client';
import { AppConfig } from './app.config';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  constructor(private router: Router) {
    const stsSettings = {
      authority: AppConfig.settings.ID4.AuthAddress,
      client_id: AppConfig.settings.ID4.Client,
      redirect_uri: AppConfig.settings.ID4.Redirect,
      scope: 'openid RNapi',
      response_type: 'code',
      post_logout_redirect_uri: AppConfig.settings.ID4.Post_Logout,
      loadUserInfo: false
    };

    this._userManager = new UserManager(stsSettings);
  }
  static _origin: string;

  private _userManager: UserManager;
  private _user: User;
  private _loginChangedSubject = new Subject<boolean>();
  public loginChanged = this._loginChangedSubject.asObservable();

  public login = () => {
    //this.router.navigate(['bff/login'], { replaceUrl: true });
    return this._userManager.signinRedirect();
  }

  public isAuthenticated = (): Promise<boolean> => {
    return this._userManager.getUser()
      .then(user => {
        if (this._user !== user) {
          this._loginChangedSubject.next(this.checkUser(user));
        }
        this._user = user;
        return this.checkUser(user);
      });
  }

  private checkUser = (user: User): boolean => {
    return !!user && !user.expired;
  }

  public finishLogin = (): Promise<User> => {
    return this._userManager.signinRedirectCallback()
      .then(user => {
        this._user = user;
        this._loginChangedSubject.next(this.checkUser(user));
        return user;
      });
  }

  public logout = () => {
    return this._userManager.signoutRedirect();
  }

  public finishLogout() {
    this._user = null;
    return this._userManager.signoutRedirectCallback();
  }
}
